import {modalTriggerLiveSiteSrc68Evid1232 as modalOpened} from '@wix/bi-logger-events-data/v2'
import {useVisitorBi} from '@wix/yoshi-flow-editor'
import React, {PropsWithChildren, useEffect} from 'react'
import {useAppHost, useAppSelector} from '../../hooks/runtime'
import {getEvent} from '../../selectors/event'
import {getModalType} from '../../selectors/modals'
import {getSeatingPlan} from '../../selectors/seating/plan'
import {ConfirmRsvp} from '../chunks/confirm-rsvp'
import {HeadlessError} from '../chunks/headless-error'
import {OrderSummary} from '../chunks/order-summary'
import {Policy} from '../chunks/policy'
import {RecurringEvents} from '../chunks/recurring-events'
import {SeatingPlanModal} from '../chunks/seating-plan-modal'
import {TicketsDownload} from '../chunks/ticket-download'
import {UpgradeToPremium} from '../chunks/upgrade-to-premium'
import {NativeModal} from './constants'

export const Modals = () => {
  const bi = useVisitorBi()
  const {blockScroll, unblockScroll} = useAppHost()

  const event = useAppSelector(getEvent)
  const modalType = useAppSelector(getModalType)
  const seatingPlan = useAppSelector(getSeatingPlan)

  useEffect(() => {
    if (modalType) {
      blockScroll?.()
      bi.report(modalOpened({modal_name: modalType, event_id: event.id}))
    } else {
      unblockScroll?.()
    }
    return () => {
      unblockScroll?.()
    }
  }, [modalType])

  switch (modalType) {
    case NativeModal.ORDER_SUMMARY:
      return (
        <LazyModalWrapper>
          <OrderSummary />
        </LazyModalWrapper>
      )
    case NativeModal.TICKETS_DOWNLOAD:
      return (
        <LazyModalWrapper>
          <TicketsDownload />
        </LazyModalWrapper>
      )
    case NativeModal.SEATING_PLAN:
      if (!seatingPlan) {
        return null
      }

      return <SeatingPlanModal />
    case NativeModal.CONFIRM_RSVP:
      return (
        <LazyModalWrapper>
          <ConfirmRsvp />
        </LazyModalWrapper>
      )
    case NativeModal.HEADLESS_ERROR:
      return (
        <LazyModalWrapper>
          <HeadlessError />
        </LazyModalWrapper>
      )
    case NativeModal.POLICY:
      return (
        <LazyModalWrapper>
          <Policy />
        </LazyModalWrapper>
      )
    case NativeModal.RECURRING_EVENTS:
      return (
        <LazyModalWrapper>
          <RecurringEvents />
        </LazyModalWrapper>
      )
    case NativeModal.UPGRADE_TO_PREMIUM:
      return (
        <LazyModalWrapper>
          <UpgradeToPremium />
        </LazyModalWrapper>
      )
    default:
      return null
  }
}

const LazyModalWrapper = ({children}: PropsWithChildren) => <React.Suspense fallback={null}>{children}</React.Suspense>
